(function () {
    'use strict';

    class OpenstcPlanningLeafletCtrl{
        constructor($scope, swifRouteService, dataService, swifCartoLeafletService, openstcResourcesService, openstc, osrmAPI) {
            this.$scope = $scope;
            this.showLeaflet = false;
            this.route = swifRouteService;
            this.data = dataService;
            this.swifCartoLeafletService = swifCartoLeafletService;
            this.openstcResources = openstcResourcesService;
            this.openstcPlanning = openstc.planning;
            this.osrmAPI = osrmAPI;
            this.osrmAPI.url = "https://router.project-osrm.org";

            this.routeOptions = {
                alternatives: false,
                steps: false,
                annotations: false,
                overview: 'simplified',
                continue_straight: 'default',
                geometries: 'geojson'
            };
        }
        $onInit() {
            var $ctrl = this;
            this.route.check({resources: ['leaflet']}).then(function () {
                $ctrl.showLeaflet = true; //TODO: add timeout here
            });
            this.$scope.$watch('$ctrl.plannedTasks.currentFilter', function (newV) {
                $ctrl.filter = newV;
            });
            this.$scope.$watch('$ctrl.plannedTasks.lastUpdateDateTime', function (newV) {
                $ctrl.updateMarkers();
            });

            this.openstcResources.onChangeCallback.leaflet = function () {
                $ctrl.onResourceChange();
            };
        }
        $onDestroy() {
            delete this.openstcResources.onChangeCallback.leaflet;
        }
        $onChanges(changesObj) {
            this.updateMarkers();
        }
        _onMapInitialized(map) {
            this.map = map;
            map.setZoom(13);
            this.updateMarkers();
            var height = $('.fc-agenda-view').parent().parent().height();
            $(map._container).height(height);
            map.invalidateSize(true);
        }
        updateMarkers(){
            var $ctrl = this;
            var service = $ctrl.swifCartoLeafletService;
            service.removeLayerFromMap($ctrl.layer, $ctrl.map);
            if (this.map && this.routes) {
                this.routes.forEach(function (route) {
                    if ($ctrl.map.hasLayer(route)) {
                        $ctrl.map.removeLayer(route);
                    }
                });
            }
            this.routes = [];
            if (!this.filter || !this.showLeaflet) {
                return;
            }
            var filter = angular.copy(this.filter);
            filter.limit = 0;
            filter.fields = ['geo_point', 'state', 'name', 'site1','swif_id'];
            this.data.addFilter(filter, '|');
            this.data.addFilter(filter, 'site1.geo_point', '!=', false);
            this.data.addFilter(filter, 'geo_point', '!=', false);
            function loadGeoPointBySiteId(data) {
                return $ctrl.loadGeoPointBySiteId(data);
            }
            function addMarkers(data) {
                return $ctrl.addMarkers(data);
            }
            this.data.searchRead(this.plannedTasks.contentType, filter)
            .then(loadGeoPointBySiteId).then(addMarkers);
        }
        getMarker(item) {
            var service = this.swifCartoLeafletService;
            var icon = service.getIconFromSite(item);
            var marker = service.getMarkerFromPoint(
                item.geo_point, {icon: icon}
            );
            var $scope = this.$scope.$new();
            $scope.collection = this.plannedTasks;
            var linkLabel;
            switch (this.plannedTasks.contentType) {
                case 'task':
                    linkLabel = 'Voir la tâche';
                    break;
                default:
                    break;
            }
            var footer = `<a class="btn btn-link"
                ng-click="collection.setCurrent(proxy.id)">
                ${linkLabel}
            </a>`;
            var html = service.getPanelHTML(
                item, $scope, {footer: footer}
            );
            marker.bindPopup(html);
            return marker;
        }
        loadGeoPointBySiteId(data) {
            var $ctrl = this;
            return $ctrl.swifCartoLeafletService.getGeoPointBySiteId(data.records).then(function (geoPointBySiteId) {
                $ctrl.geoPointBySiteId = geoPointBySiteId;
                return data;
            });
        }
        addMarkers(data) {
            var $ctrl = this;
            //get geo_point by site id
            var markers = [];
            data.records.forEach(function (item) {
                if (!item.geo_point && item.site1) {
                    item.geo_point = $ctrl.geoPointBySiteId[item.site1[0]];
                }
                var marker = $ctrl.getMarker(item);
                if (marker) {
                    markers.push(marker);
                }
            });
            if (this.map && markers.length > 0) {
                var layer = L.featureGroup(markers);
                this.layer = L.markerClusterGroup();
                this.layer.options.spiderfyOnMaxZoom = false;
                this.layer.options.disableClusteringAtZoom= 20;
                this.layer.addLayer(layer);
                this.layer.addTo(this.map);
                this.map.fitBounds(this.layer.getBounds());
            }
            if (markers.length === 0) {
                // when we don't have any markers, we set the view on the default geolocation
                $ctrl.swifCartoLeafletService.setDefaultCenterView(this.map);
            }
            this.updateRoutes();
        }

        onResourceChange() {
            this.updateMarkers();
        }
        updateRoutes() {
            /**
             * assertion: I need resources + start & end
             * get the select users
             * for each user
             * get the tasks ordered
             *  SELECT date_start, site1, geo_point
                FROM project_task
                WHERE user_id = user AND team_id in [user.team_ids] AND date_start = day
                SORT on date_start

             * compute  route between each task.geo_point||site.geo_point
             */
            var $ctrl = this;
            var resources = this.openstcResources.getCurrent();
            var start = this.openstcPlanning.currentStart;
            var end = this.openstcPlanning.currentEnd;
            if (!resources.officers){
                return;
            }
            if ((resources.officers.length <= 0) || !start || !end) {
                return;
            }
            resources.officers.forEach(function (officer) {
                $ctrl.getOrderedTasks(officer, start, end)
                .then(function (data) {
                    data.records.forEach(function (task, index) {
                        if (data.records[index+1]) {
                            $ctrl.addRoute(task, data.records[index+1], officer);
                        }
                    });
                });
            });
        }
        addRoute(taskStart, taskEnd, officer) {
            var $ctrl = this;
            var start = taskStart.geo_point;
            var end = taskEnd.geo_point;
            if (!start) {
                start = $ctrl.geoPointBySiteId[taskStart.site1[0]];
            }
            if (!end) {
                end = $ctrl.geoPointBySiteId[taskEnd.site1[0]];
            }
            if (!start || !end) {
                if (!start) {
                    console.log(`site ${taskStart.site1[1]} not localized`);
                }
                if (!end) {
                    console.log(`site ${taskEnd.site1[1]} not localized`);
                }
                return;
            }
            let getLatLng = $ctrl.swifCartoLeafletService.getLatLngFromPoint;
            let startLatlng = getLatLng(start);
            let endLatlng = getLatLng(end);
            var coordinates = `${startLatlng[1]},${startLatlng[0]};${endLatlng[1]},${endLatlng[0]}`;

            this.osrmAPI.route('car', coordinates, this.routeOptions).then(function (data) {
                if (Array.isArray(data.data.routes)) {
                    data.data.routes.forEach(function (route) {
                        if (!route.geometry) {
                            return data;
                        }
                        var layer = L.geoJson(route.geometry, {color: officer.hex_color})
                            .addTo($ctrl.map);
                        $ctrl.routes.push(layer);
                    });
                }
            });
        }
        getOrderedTasks(officer, start, end) {
            var filter = {};
            var options = {
                start: start,
                end: end,
                officers: [officer]
            };
            this.openstcPlanning.updateFilter(filter, options);
            filter.fields = ['geo_point', 'date_start', 'date_end', 'site1'];
            this.data.sortOn(filter, 'date_start');
            return this.data.searchRead('task', filter);
        }
    }
    OpenstcPlanningLeafletCtrl.$inject = [
        '$scope',
        'swifRouteService',
        'dataService',
        'swifCartoLeafletService',
        'openstcResourcesService',
        'swifInterventionsService',
        'osrmAPI'
    ];

    angular.module('swif.carto')

    .component('openstcPlanningLeaflet', {
        template: `<div ng-if="$ctrl.showLeaflet" class="widemap">
            <swif-leaflet leaflet-show="$ctrl.leafletShow" on-map-initialized="$ctrl._onMapInitialized(map)">
            </swif-leaflet>
        </div>`,
        controller: OpenstcPlanningLeafletCtrl,
        bindings: {
            plannedTasks: '<',
            leafletShow: '<'
        }
    });


})();
